import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import { adminCreateMachine, adminUpdateMachine, adminListMachines } from '../../services/toolsApi';

const AdminMachineForm = () => {
  const { machineId } = useParams();
  const isEdit = !!machineId;
  const navigate = useNavigate();
  const { password } = useAdmin();
  const [loading, setLoading] = useState(isEdit);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    id: '',
    name_uk: '',
    name_ru: '',
    location_uk: '',
    location_ru: '',
    is_active: 1,
  });

  useEffect(() => {
    if (!isEdit) return;
    adminListMachines(password).then((machines) => {
      const m = machines.find((x) => x.id === machineId);
      if (m) {
        setForm({
          id: m.id,
          name_uk: m.name.uk,
          name_ru: m.name.ru,
          location_uk: m.location.uk,
          location_ru: m.location.ru,
          is_active: m.isActive ? 1 : 0,
        });
      }
      setLoading(false);
    });
  }, [isEdit, machineId, password]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (isEdit) {
        await adminUpdateMachine(password, form);
      } else {
        await adminCreateMachine(password, form);
      }
      navigate('/admin');
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center py-12"><div className="w-8 h-8 border-3 border-dewalt border-t-transparent rounded-full animate-spin" /></div>;
  }

  return (
    <div className="max-w-lg">
      <h1 className="text-xl font-bold text-black mb-6">
        {isEdit ? 'Edit Machine' : 'New Machine'}
      </h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">ID</label>
          <input
            name="id"
            value={form.id}
            onChange={handleChange}
            disabled={isEdit}
            required
            placeholder="e.g. vending-002"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm outline-none focus:border-dewalt disabled:bg-gray-100"
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Name (UK)</label>
            <input name="name_uk" value={form.name_uk} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm outline-none focus:border-dewalt" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Name (RU)</label>
            <input name="name_ru" value={form.name_ru} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm outline-none focus:border-dewalt" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Location (UK)</label>
            <input name="location_uk" value={form.location_uk} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm outline-none focus:border-dewalt" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Location (RU)</label>
            <input name="location_ru" value={form.location_ru} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm outline-none focus:border-dewalt" />
          </div>
        </div>

        <label className="flex items-center gap-2 cursor-pointer">
          <input type="checkbox" name="is_active" checked={form.is_active === 1} onChange={handleChange} className="w-4 h-4" />
          <span className="text-sm text-gray-700">Active</span>
        </label>

        <div className="flex gap-3 pt-2">
          <button
            type="submit"
            disabled={saving}
            className="px-6 py-2.5 bg-dewalt border-none rounded-lg text-sm font-bold text-black cursor-pointer hover:bg-dewalt-hover disabled:opacity-50"
          >
            {saving ? 'Saving...' : isEdit ? 'Update' : 'Create'}
          </button>
          <button
            type="button"
            onClick={() => navigate('/admin')}
            className="px-6 py-2.5 bg-gray-100 border-none rounded-lg text-sm font-medium text-gray-700 cursor-pointer hover:bg-gray-200"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminMachineForm;
